// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3H-Ym","containerItemsCenter":"Skeleton_containerItemsCenter__2PgtU"};